$(document).ready(function(){

    $('.js-select2').select2();
});
